import { message } from 'antd';
import { exportPdfTable, downloadUtf8Csv } from '@/shared/lib/jspdfCyrillic';
import type { ReportDefinition } from '@/entities/report/model/reportSchema';

export function generateReportPdf(r: ReportDefinition, period?: string, dept?: string): void {
  const suffix = [period, dept].filter(Boolean).join(', ');
  const title = suffix ? `${r.title} (${suffix})` : r.title;
  void exportPdfTable({
    title,
    fileSlug: r.title.replace(/\s+/g, '_'),
    head: [['Отчёт', 'Модуль', 'Период', 'Подразделение', 'Дата формирования']],
    body: [[r.title, r.module, period || 'Весь период', dept || 'Все', new Date().toLocaleDateString('ru-RU')]],
  }).then(() => message.success('PDF сохранён'));
}

export function generateReportCsv(r: ReportDefinition, period?: string, dept?: string): void {
  downloadUtf8Csv(`${r.title.replace(/\s+/g, '_')}_Р7.csv`, 'Отчёт;Модуль;Период;Подразделение;Дата формирования', [
    [r.title, r.module, period || 'Весь период', dept || 'Все', new Date().toLocaleDateString('ru-RU')],
  ]);
  message.success('Файл для Р7 (CSV) сохранён');
}
